import React from 'react';
import PDF from '../../../Components/PDF'

function IsingModel() {
  return (
    <div style={{ height: '100vh' }}>
      <PDF file='/isingmodel.pdf'/>
    </div>
  );
}

export default IsingModel;
